module.exports = __webpack_public_path__ + "img/advantage3.adede3a4.png";